import { render } from "./CommingSoon.vue?vue&type=template&id=252456a9&scoped=true"
import script from "./CommingSoon.vue?vue&type=script&lang=js"
export * from "./CommingSoon.vue?vue&type=script&lang=js"

import "./CommingSoon.vue?vue&type=style&index=0&id=252456a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252456a9"]])

export default __exports__